import { Dialogs } from '@leverege/ui-elements';
import ZoneBeaconPairing from '../../views/zoneBeaconPairing/ZoneBeaconPairing';
export default {
  id: 'api-pairing-location.zones.beacon.pair',
  name: 'Pair Beacons to Zones',
  matches: {
    client: 'GroupScreen',
    use: 'actionBar',
    objectType: 'zone',
    path: 'location.zones'
  },
  handles: () => true,
  appearance: () => {
    return {
      name: 'Pair',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/pair_action_icon.png'
    };
  },
  perform: props => {
    const {
      context
    } = props;
    const {
      clientProps
    } = context;
    const {
      actions
    } = clientProps;
    Dialogs.show({
      id: 'beacon-zone-pairing',
      component: ZoneBeaconPairing,
      props: {
        ...props,
        actions
      }
    });
  }
};